import React, { Component } from 'react';
import BaseComponent from '../../../components/system/base';
class StartButton extends BaseComponent {
  render() {
    return(
      <button className="StartButton" {...this.globs.touchAndClick(this.props.clicked)}></button>
    )
  }
}

export default StartButton;


// WEBPACK FOOTER //
// ./src/content/winPrize/slotComponents/StartButton.js